// extracted by mini-css-extract-plugin
module.exports = {"list":"SitterPets_list__t1WWW"};